import './FeaturedProjects.css'; // Import corresponding CSS file

const FeaturedProjects = () => {
  const projects = [
    {
      id: 1,
      title: 'H_News',
      description: 'H_News is an Android application built with Kotlin using the HackerNews API that provides the latest news articles from various sources. It features a sleek and modern user interface, making it easy for users to stay updated with current events.',
      imageUrl: 'https://i.pinimg.com/736x/6b/bd/f7/6bbdf7e97eb4027e443796bf9fa2bf42.jpg', 
      githubLink: 'https://github.com/Aditys018/H_News',
      demoLink: 'https://github.com/Aditys018/H_News'
    },
     {
      id: 2,
      title: 'WealthApp',
      description: 'WealthApp is a full-stack application that helps users manage and visualize wealth-related data using maps and intuitive UI. The project is built using React 19, Vite, Tailwind CSS, and TanStack Router on the frontend, with a Node.js, Express, and MongoDB backend. It also supports features like Google Maps integration, JWT authentication, cloud storage, and scheduled tasks.',
      imageUrl: 'https://i.pinimg.com/736x/8c/ac/ae/8cacae7409c7e0da37b0bb1657316dfc.jpg', 
      githubLink: 'https://github.com/Aditys018/WealthApp',
      demoLink: 'https://wealth-map.netlify.app/'
    },
    {
      id: 3,
      title: 'Customized Virtual File System',
      description: 'This project emulates all the data structures which are used by OS to manage files system oriented tasks. This project contains all the important system calls and commands of file subsystem as Open, Close, Read, Write, Lseek, Create, RM, LS, Stat, Fstat etc. By using this project, we can get overview of Unix File System on any platform.',
      imageUrl: 'https://i.pinimg.com/736x/c7/94/eb/c794ebc26b5bae8007c0007c4cbbc973.jpg',
      githubLink: 'https://github.com/Aditys018/Customized_Dynamic_File_System',
      demoLink: 'https://github.com/Aditys018/Customized_Dynamic_File_System'
    },
    
   
    // Add more projects as needed
  ];

  return (
    <div className="featured-projects-container">
      <h1>FEATURED PROJECTS</h1>
      {projects.map((project, index) => (
        <div key={project.id} className={`project-container project${index + 1}`}>
          <div className="project-image">
            <img src={project.imageUrl} alt={`Project ${project.id}`} />
          </div>
          <div className="project-details">
            <h2>{project.title}</h2>
            <p>{project.description}</p>
            <div className="project-links">
              <a href={project.githubLink} target="_blank" rel="noopener noreferrer">GitHub Repo</a>
              <a href={project.demoLink} target="_blank" rel="noopener noreferrer">Demo</a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturedProjects;
